import {
  isActionTypeDisplay,
  isElementTypeContainer,
} from '@/common/converter/utils/element'

export const getExecuteUrl = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action = element?.actionList?.find(isActionTypeDisplay) ?? {}

  return action?.execute?.data?.url ?? ''
}
